// Articles list + single article page strings — namespace `articles`
export default {
  en: {
    heading: 'From the journal',
    // vue-i18n pipe-separated pluralization: 1 = singular, 2+ = plural.
    articleCount: '{count} article | {count} articles',
    error: 'Could not load articles.',
    empty: 'No articles published yet.',
    badge: 'Article',
    pagination: {
      prev: 'Previous',
      next: 'Next',
      page: 'Page {page} of {pages}',
    },
    notFound: {
      heading: 'Article not found',
      body: "It may have been removed or isn't published yet.",
      back: 'All articles',
    },
    back: 'All articles',
    breadcrumb: 'Journal',
    latest: 'Latest',
    readMore: 'Read article',
    browse: 'Browse games',
    readTime: '{count} min read',
    toc: 'In this article',
    share: {
      label: 'Share',
      copy: 'Copy link',
      copied: 'Link copied',
      copyFailed: 'Could not copy the link',
    },
    related: 'More from the journal',
    newReleases: 'New releases',
  },
  cs: {
    heading: 'Z deníku',
    // Czech has three plural forms: 1 / 2–4 / 5+.
    articleCount: '{count} článek | {count} články | {count} článků',
    error: 'Nepodařilo se načíst články.',
    empty: 'Zatím nebyly zveřejněny žádné články.',
    badge: 'Článek',
    pagination: {
      prev: 'Předchozí',
      next: 'Další',
      page: 'Strana {page} z {pages}',
    },
    notFound: {
      heading: 'Článek nenalezen',
      body: 'Mohl být odstraněn nebo ještě není zveřejněn.',
      back: 'Všechny články',
    },
    back: 'Všechny články',
    breadcrumb: 'Deník',
    latest: 'Nejnovější',
    readMore: 'Číst článek',
    browse: 'Procházet hry',
    // Same form for every count in Czech ("min" is an abbreviation).
    readTime: '{count} min čtení',
    toc: 'V tomto článku',
    share: {
      label: 'Sdílet',
      copy: 'Kopírovat odkaz',
      copied: 'Odkaz zkopírován',
      copyFailed: 'Odkaz se nepodařilo zkopírovat',
    },
    related: 'Další z deníku',
    newReleases: 'Novinky',
  },
};
